<template>
    <section class="review-grid">
        <q-card flat bordered>
            <q-card-section>
                <div class="review-title">
                    <q-icon name="person" color="primary" />
                    <strong>Person</strong>
                </div>
                <p v-if="personMode === 'existing'">
                    Use existing person: <strong>{{ personName }}</strong>
                </p>
                <p v-else>
                    Create new person: <strong>{{ proposedPersonName }}</strong>
                </p>
            </q-card-section>
        </q-card>

        <q-card flat bordered>
            <q-card-section>
                <div class="review-title">
                    <q-icon name="work_outline" color="primary" />
                    <strong>Client Engagement</strong>
                </div>
                <p><strong>Service:</strong> {{ serviceLabel }}</p>
                <p><strong>Entry date:</strong> {{ engagement.enteredDate || "Not provided" }}</p>
                <p><strong>Referral source:</strong> {{ referralSourceLabel }}</p>
            </q-card-section>
        </q-card>

        <q-card flat bordered>
            <q-card-section>
                <div class="review-title">
                    <q-icon name="description" color="primary" />
                    <strong>Referral</strong>
                </div>
                <p v-if="referralFile">
                    {{ referralFile.name }} ({{ formattedFileSize }})
                </p>
                <p v-else>No referral document will be attached.</p>
                <p v-if="formName">Information from {{ formName }} has been reviewed.</p>
            </q-card-section>
        </q-card>

        <q-card v-if="referralSpecificCount" flat bordered>
            <q-card-section>
                <div class="review-title">
                    <q-icon name="list_alt" color="primary" />
                    <strong>Referral-specific information</strong>
                </div>
                <p>
                    {{ referralSpecificCount }}
                    detail{{ referralSpecificCount === 1 ? "" : "s" }} will be saved with the
                    Client Engagement.
                </p>
            </q-card-section>
        </q-card>

        <q-banner class="bg-orange-1 text-orange-10 review-approval" rounded>
            Approve and create confirms that you have checked the person, Client Engagement,
            and any referral information shown above.
        </q-banner>
    </section>
</template>

<script>
import { tkPersonName } from "@/services/util/formSubject";

export default {
    name: "ReferralReviewSummary",
    props: {
        personMode: {
            type: String,
            required: true,
        },
        selectedPerson: {
            type: [Object, null],
            required: false,
        },
        personDraft: {
            type: Object,
            required: true,
        },
        engagement: {
            type: Object,
            required: true,
        },
        serviceOptions: {
            type: Array,
            required: true,
        },
        referralSourceOptions: {
            type: Array,
            required: true,
        },
        referralFile: {
            type: [Object, null],
            required: false,
        },
        formName: {
            type: [String, null],
            required: false,
        },
        referralSpecificCount: {
            type: Number,
            required: true,
        },
    },
    computed: {
        personName() {
            return this.selectedPerson ? tkPersonName(this.selectedPerson) : "Not selected";
        },
        proposedPersonName() {
            return [this.personDraft.first_name, this.personDraft.last_name]
                .filter(Boolean)
                .join(" ")
                .trim() || "Name required";
        },
        serviceLabel() {
            return this.serviceOptions.find(option => option.value === this.engagement.serviceCode)?.label
                || this.engagement.serviceCode
                || "Not selected";
        },
        referralSourceLabel() {
            return this.referralSourceOptions.find(option => option.value === this.engagement.referralSource)?.label
                || this.engagement.referralSource
                || "Not provided";
        },
        formattedFileSize() {
            const bytes = Number(this.referralFile?.size || 0);
            if (bytes < 1024) return `${bytes} B`;
            if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
            return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
        },
    },
};
</script>

<style scoped>
.review-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.review-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.review-grid p {
    margin: 4px 0;
    color: #46555a;
}

.review-approval {
    grid-column: 1 / -1;
}

@media (max-width: 700px) {
    .review-grid {
        grid-template-columns: 1fr;
    }
}
</style>
